module.exports = __webpack_public_path__ + "img/pref.08a01193.svg";